import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7812253c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "modal-body flex-colum",
  style: {"overflow":"hidden","height":"70vh"}
}
const _hoisted_8 = { style: {"overflow-y":"scroll","margin-top":"10px"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "modal-footer2 flex-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          class: "modal-header-close"
        }, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
          placeholder: "搜索"
        }, null, 512), [
          [_vModelText, _ctx.search]
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showList, (v, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex-row flex-align-center ck-item",
              onClick: ($event: any) => (_ctx.select(v))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((v.selected) = $event),
                class: "mr-2"
              }, null, 8, _hoisted_10), [
                [_vModelCheckbox, v.selected]
              ]),
              _createElementVNode("div", null, _toDisplayString(v.name) + " (" + _toDisplayString(v.jobTitle) + ")", 1)
            ], 8, _hoisted_9))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, "确定")
      ])
    ])
  ]))
}